import { Toggle } from 'components/Toggle'
import {
    FieldErrors,
    FieldValues,
    UseFormRegister,
} from 'react-hook-form'
import { NotificationType } from 'types/notification';
import { IVariable } from 'types/variable';
import { NotifyUpdateEventType } from 'validator/notify_complementary_infos'

export interface PatientsInvolved {
    name: string;
    choices: IVariable[]
}

interface InvolvedPatientsProps {
    errors: FieldErrors<FieldValues>
    register: UseFormRegister<FieldValues>
    watchFormData: NotifyUpdateEventType
    variablePatientsInvolved: PatientsInvolved
    notification?: NotificationType,
}

const involvedDamageLevels = [
    '19d0c798db76a1108394816404961944',
    '0bd6cbdcdb76a110839481640496192f',
    '62270310dbb6a1108394816404961970',
    '6e37039cdb76a110839481640496191f'
]

export const InvolvedPatients = ({
    register,
    errors,
    watchFormData,
    variablePatientsInvolved,
    notification
}: InvolvedPatientsProps) => {
    if (!watchFormData.involves_patient || !involvedDamageLevels.includes(watchFormData.damage_level)) {
        return null
    }

    return (
        <div className="w-full">
            <label className='block font-semibold text-xs text-darkGray pb-0.5 mt-4 mb-1'>
                Quantos pacientes estão relacionados a este incidente
            </label>
            <Toggle
                register={register}
                name={variablePatientsInvolved?.name}
                itens={[
                    {
                        id: 1,
                        title: variablePatientsInvolved?.choices?.[1]?.label,
                        value: variablePatientsInvolved?.choices?.[1]?.value
                    },
                    {
                        id: 2,
                        title: variablePatientsInvolved?.choices?.[2]?.label,
                        value: variablePatientsInvolved?.choices?.[2]?.value
                    }
                ]}
                defaultCheckedValue={notification?.u_number_patients_involved?.value}
            />
            <span className="text-errorText text-xs">
                {errors.u_number_patients_involved ? 'Preenchimento obrigatório.' : ''}
            </span>
        </div>
    )
}
